import type Integration from "src/integrations/objects/Integration";
import type IntegrationType from "src/integrations/objects/IntegrationType";
import { INTEGRATIONS } from "src/integrations/views/Integrations";

export const INTEGRATION_MERCHANT_GROUP_UUID = "merchantGroupUuid";
export const INTEGRATION_MERCHANT_UUID = "merchantUuid";
export const INTEGRATION_STORE_UUID = "storeUuid";

export interface IIntegrationFormData {
  [INTEGRATION_MERCHANT_GROUP_UUID]: string;
  [INTEGRATION_MERCHANT_UUID]: string;
  [INTEGRATION_STORE_UUID]: string;
}

export function integrationDataToIntegration(
  integrationType: IntegrationType,
  integrationData: Partial<IIntegrationFormData>,
  integrationUuid?: string,
): Partial<Integration> {
  const integration: Partial<Integration> = {
    integrationType,
    integrationUuid,
  };
  const { isMerchantBased } = INTEGRATIONS[integrationType];
  integration.merchantGroupUuid =
    integrationData[INTEGRATION_MERCHANT_GROUP_UUID];
  integration.merchantUuid = integrationData[INTEGRATION_MERCHANT_UUID];
  if (!isMerchantBased) {
    integration.storeUuid = integrationData[INTEGRATION_STORE_UUID];
  }
  return integration;
}

export function integrationToIntegrationData(
  integrationType: IntegrationType,
  integration: Integration,
): Partial<IIntegrationFormData> {
  const integrationFormData: Partial<IIntegrationFormData> = {
    [INTEGRATION_MERCHANT_GROUP_UUID]: integration.merchantGroupUuid,
    [INTEGRATION_MERCHANT_UUID]: integration.merchantUuid,
  };
  const { isMerchantBased } = INTEGRATIONS[integrationType];
  if (!isMerchantBased) {
    integrationFormData[INTEGRATION_STORE_UUID] = integration.storeUuid;
  }
  return integrationFormData;
}
